// Suivi des envois d'une proposition : statut (envoyée / délivrée / échec), renvoi, copie de secours
import { useState, useEffect } from "react";
import axios from "axios";
import { C, Btn, fdatetime, authDownload, errMsg } from "./shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const hdr = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("auprea_token")}` } });
const DOCS = { proposition: "Proposition", lettre_mission: "Lettre de mission", cgv: "CGV", retractation: "Formulaire de rétractation", signe: "Proposition signée" };
const colorOf = (e) => (e.echec ? C.red : ["delivered", "opened", "clicked"].includes(e.statut) ? C.green : C.amber);

export const EnvoisProposition = ({ parcoursId, refreshKey }) => {
  const [d, setD] = useState(null);
  const [msg, setMsg] = useState("");
  const [busy, setBusy] = useState(false);
  const load = () => axios.get(`${API}/parcours/${parcoursId}/proposition/envois`, hdr()).then(r => setD(r.data)).catch(() => {});
  useEffect(() => { load(); }, [parcoursId, refreshKey]); // eslint-disable-line react-hooks/exhaustive-deps
  if (!d || (!d.envois.length && !d.lien)) return null;
  const renvoyer = async () => {
    if (!window.confirm(`Renvoyer la proposition à ${d.email_client} ?`)) return;
    setBusy(true); setMsg("");
    try { await axios.post(`${API}/parcours/${parcoursId}/proposition/renvoyer`, {}, hdr()); setMsg("Proposition renvoyée ✓"); load(); }
    catch (e) { setMsg(errMsg(e)); }
    setBusy(false);
  };
  const copier = async () => { try { await navigator.clipboard.writeText(d.lien); setMsg("Lien copié ✓ — vous pouvez le transmettre par SMS ou WhatsApp"); } catch { setMsg(d.lien); } };
  const dernier = d.envois[0];
  return (
    <div data-testid="envois-proposition" style={{ background: "#fff", border: `.5px solid ${C.border}`, borderLeft: `3px solid ${dernier ? colorOf(dernier) : C.gold}`, borderRadius: 10, padding: 14, marginTop: 14 }}>
      <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", gap: 10, flexWrap: "wrap" }}>
        <div>
          <div style={{ fontSize: 13, fontWeight: 700, color: C.navy }}>Envoi au client{d.numero ? ` — proposition N°${d.numero}` : ""}</div>
          {dernier && <div style={{ fontSize: 12, color: colorOf(dernier), fontWeight: 600 }} data-testid="envoi-statut">{dernier.statut_label} · {dernier.to} · {fdatetime(dernier.at)}</div>}
          {dernier?.echec && dernier.raison && <div style={{ fontSize: 11, color: C.mid }}>{dernier.raison}</div>}
        </div>
        <div style={{ display: "flex", gap: 6, flexWrap: "wrap" }}>
          {d.peut_renvoyer && <Btn small variant="gold" disabled={busy} onClick={renvoyer} data-testid="envoi-renvoyer">↻ Renvoyer</Btn>}
          {d.lien && <Btn small onClick={copier} data-testid="envoi-copier-lien">Copier le lien</Btn>}
          {d.documents.map(x => <Btn key={x.doc} small onClick={() => authDownload(`/parcours/${parcoursId}/proposition/copie/${x.doc}`, `${x.doc}-${d.numero}.pdf`)} data-testid={`envoi-pdf-${x.doc}`}>⬇ {DOCS[x.doc] || x.doc}</Btn>)}
        </div>
      </div>
      {msg && <div style={{ fontSize: 12, color: C.navy, marginTop: 8, wordBreak: "break-all" }} data-testid="envoi-message">{msg}</div>}
      {d.envois.length > 1 && (
        <div style={{ marginTop: 8, fontSize: 11, color: C.muted }}>
          {d.envois.slice(1, 6).map(e => <div key={e.id}>{fdatetime(e.at)} · {e.to} · <span style={{ color: colorOf(e) }}>{e.statut_label}</span></div>)}
        </div>
      )}
    </div>
  );
};
